// import { shade } from 'polished'

export const LightTheme = {
  title: 'Light',
  colors: {
    primary: {
      lighter: '#6866FB',
      light: '#5659EB',
      normal: '#4347FE',
      dark: '#494CDB',
      darker: '#3846D4'
    },
    secondary: '#E02041',
    tertiary: '#F0F0F7',

    background: {
      lighter: '#2c323f',
      light: '#232832',
      normal: '#F0F0F7',
      dark: '#161a20',
      darker: '#12151a'
    },
    text: {
      light: '#D4C2FF',
      normal: '#9C98A6',
      dark: '#6A6180',
      title: '#1a1b1f'
    },

    white: '#f7f7f7',
    grey: 'aeaeb0',
    opaque: '#41414D',
    purple: '#6633cc',
    purpleDark: '#5A4B81',
    green: '#67e480',
    orange: '#E89E64',
    pink: '#FF79C6',
    blue: '#2436e8' /** #5659eb */,
    lightBlue: '#3AC5FF',
    red: '#E96379',
    yellow: '#e7de79'
  }
}

export const DarkTheme = {
  title: 'Dark',
  colors: {
    primary: {
      lighter: '#6866FB',
      light: '#5659EB',
      normal: '#4347FE',
      dark: '#494CDB',
      darker: '#3846D4'
    },
    secondary: '#E02041',
    tertiary: '#2B303A',

    background: {
      lighter: '#1C2028',
      light: '#171719',
      normal: '#121214',
      dark: '#0E0E10',
      darker: '#000'
    },
    text: {
      light: '#fff',
      normal: '#7B7B7C',
      dark: '#6A6180',
      title: '#E3E6EC'
    },

    white: '#f7f7f7',
    grey: 'aeaeb0',
    opaque: '#41414D',
    purple: '#6633cc',
    purpleDark: '#5A4B81',
    green: '#67e480',
    orange: '#E89E64',
    pink: '#FF79C6',
    blue: '#2436e8' /** #5659eb */,
    lightBlue: '#3AC5FF',
    red: '#E96379',
    yellow: '#FFC500'
  }
}
